/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Defect Service API
 * Defect tracking and corrective action management for CTE platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CloseOutDefectDTO,
  CorrectiveActionDTO,
  CreateCorrectiveActionDTO,
  CreateDefectDTO,
  DefectDTO,
  DefectListResponseDTO,
  DefectPhotoResponse,
  DefectSummaryResponse,
  ErrorResponse,
  GetDefectSummaryParams,
  LinkDefectPhotoRequest,
  ListDefectsParams,
  PurgeSiteDefectsResponse,
  SetCorrectiveActionCompletedDTO,
  UpdateDefectDTO,
  UpdateDefectStatusDTO,
  ValidationErrorResponse
} from './model';

import { customFetch } from './custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetDefectSummaryUrl = (params?: GetDefectSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/defects/summary?${stringifiedParams}` : `/api/defects/summary`
}

/**
 * Site scope is derived from the authenticated user's site claims (X-Site-Claims header).
 * Optionally narrow the summary to a single site by passing the `siteId` query param —
 * the site must be present in the caller's claims or the request is rejected.
 * @summary Get defect summary counts for dashboard
 */
export const getDefectSummary = async (params?: GetDefectSummaryParams, options?: RequestInit): Promise<DefectSummaryResponse> => {

  return customFetch<DefectSummaryResponse>(getGetDefectSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDefectSummaryQueryKey = (params?: GetDefectSummaryParams,) => {
    return [
    `/api/defects/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDefectSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDefectSummary>>, TError = ErrorResponse>(params?: GetDefectSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefectSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefectSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefectSummary>>> = ({ signal }) => getDefectSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDefectSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDefectSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDefectSummary>>>
export type GetDefectSummaryQueryError = ErrorResponse


export function useGetDefectSummary<TData = Awaited<ReturnType<typeof getDefectSummary>>, TError = ErrorResponse>(
 params: undefined |  GetDefectSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefectSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefectSummary>>,
          TError,
          Awaited<ReturnType<typeof getDefectSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefectSummary<TData = Awaited<ReturnType<typeof getDefectSummary>>, TError = ErrorResponse>(
 params?: GetDefectSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefectSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefectSummary>>,
          TError,
          Awaited<ReturnType<typeof getDefectSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefectSummary<TData = Awaited<ReturnType<typeof getDefectSummary>>, TError = ErrorResponse>(
 params?: GetDefectSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefectSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get defect summary counts for dashboard
 */

export function useGetDefectSummary<TData = Awaited<ReturnType<typeof getDefectSummary>>, TError = ErrorResponse>(
 params?: GetDefectSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefectSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDefectSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDefectsUrl = (params?: ListDefectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/defects?${stringifiedParams}` : `/api/defects`
}

/**
 * @summary List defects with pagination
 */
export const listDefects = async (params?: ListDefectsParams, options?: RequestInit): Promise<DefectListResponseDTO> => {

  return customFetch<DefectListResponseDTO>(getListDefectsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDefectsInfiniteQueryKey = (params?: ListDefectsParams,) => {
    return [
    'infinite', `/api/defects`, ...(params ? [params] : [])
    ] as const;
    }

export const getListDefectsQueryKey = (params?: ListDefectsParams,) => {
    return [
    `/api/defects`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDefectsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listDefects>>, ListDefectsParams['offset']>, TError = ErrorResponse>(params?: ListDefectsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData, QueryKey, ListDefectsParams['offset']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDefectsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDefects>>, QueryKey, ListDefectsParams['offset']> = ({ signal, pageParam }) => listDefects({...params, 'offset': pageParam ?? params?.['offset']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData, QueryKey, ListDefectsParams['offset']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDefectsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listDefects>>>
export type ListDefectsInfiniteQueryError = ErrorResponse


export function useListDefectsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listDefects>>, ListDefectsParams['offset']>, TError = ErrorResponse>(
 params: undefined |  ListDefectsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData, QueryKey, ListDefectsParams['offset']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDefects>>,
          TError,
          Awaited<ReturnType<typeof listDefects>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDefectsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listDefects>>, ListDefectsParams['offset']>, TError = ErrorResponse>(
 params?: ListDefectsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData, QueryKey, ListDefectsParams['offset']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDefects>>,
          TError,
          Awaited<ReturnType<typeof listDefects>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDefectsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listDefects>>, ListDefectsParams['offset']>, TError = ErrorResponse>(
 params?: ListDefectsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData, QueryKey, ListDefectsParams['offset']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List defects with pagination
 */

export function useListDefectsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listDefects>>, ListDefectsParams['offset']>, TError = ErrorResponse>(
 params?: ListDefectsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData, QueryKey, ListDefectsParams['offset']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDefectsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListDefectsQueryOptions = <TData = Awaited<ReturnType<typeof listDefects>>, TError = ErrorResponse>(params?: ListDefectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDefectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDefects>>> = ({ signal }) => listDefects(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDefectsQueryResult = NonNullable<Awaited<ReturnType<typeof listDefects>>>
export type ListDefectsQueryError = ErrorResponse


export function useListDefects<TData = Awaited<ReturnType<typeof listDefects>>, TError = ErrorResponse>(
 params: undefined |  ListDefectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDefects>>,
          TError,
          Awaited<ReturnType<typeof listDefects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDefects<TData = Awaited<ReturnType<typeof listDefects>>, TError = ErrorResponse>(
 params?: ListDefectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDefects>>,
          TError,
          Awaited<ReturnType<typeof listDefects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDefects<TData = Awaited<ReturnType<typeof listDefects>>, TError = ErrorResponse>(
 params?: ListDefectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List defects with pagination
 */

export function useListDefects<TData = Awaited<ReturnType<typeof listDefects>>, TError = ErrorResponse>(
 params?: ListDefectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDefects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDefectsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDefectUrl = () => {




  return `/api/defects`
}

/**
 * @summary Create a new defect record
 */
export const createDefect = async (createDefectDTO: CreateDefectDTO, options?: RequestInit): Promise<DefectDTO> => {

  return customFetch<DefectDTO>(getCreateDefectUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDefectDTO)
  }
);}





export const getCreateDefectMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDefect>>, TError,{data: CreateDefectDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDefect>>, TError,{data: CreateDefectDTO}, TContext> => {

const mutationKey = ['createDefect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDefect>>, {data: CreateDefectDTO}> = (props) => {
          const {data} = props ?? {};

          return  createDefect(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDefectMutationResult = NonNullable<Awaited<ReturnType<typeof createDefect>>>
    export type CreateDefectMutationBody = CreateDefectDTO
    export type CreateDefectMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Create a new defect record
 */
export const useCreateDefect = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDefect>>, TError,{data: CreateDefectDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDefect>>,
        TError,
        {data: CreateDefectDTO},
        TContext
      > => {
      return useMutation(getCreateDefectMutationOptions(options), queryClient);
    }

export const getPurgeSiteDefectsUrl = (siteId: string,) => {




  return `/api/sites/${siteId}/defects/purge`
}

/**
 * Empties a site's defect records while the site, its equipment and its
 * inspections stay in place. All rows go in one transaction. One
 * `defect.deleted` and one `audit.defect.recorded` event go out per row,
 * and one `audit.site.recorded` summary with action `purged` records the
 * count on the site's timeline.
 *
 * **Auth:** platform admin only. A manager with a claim on the site can
 * delete defects one at a time, but cannot empty the site in one call.
 * @summary Delete every defect on a site
 */
export const purgeSiteDefects = async (siteId: string, options?: RequestInit): Promise<PurgeSiteDefectsResponse> => {

  return customFetch<PurgeSiteDefectsResponse>(getPurgeSiteDefectsUrl(siteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPurgeSiteDefectsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purgeSiteDefects>>, TError,{siteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof purgeSiteDefects>>, TError,{siteId: string}, TContext> => {

const mutationKey = ['purgeSiteDefects'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purgeSiteDefects>>, {siteId: string}> = (props) => {
          const {siteId} = props ?? {};

          return  purgeSiteDefects(siteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PurgeSiteDefectsMutationResult = NonNullable<Awaited<ReturnType<typeof purgeSiteDefects>>>

    export type PurgeSiteDefectsMutationError = ErrorResponse

    /**
 * @summary Delete every defect on a site
 */
export const usePurgeSiteDefects = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purgeSiteDefects>>, TError,{siteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof purgeSiteDefects>>,
        TError,
        {siteId: string},
        TContext
      > => {
      return useMutation(getPurgeSiteDefectsMutationOptions(options), queryClient);
    }

export const getGetDefectByIdUrl = (id: string,) => {




  return `/api/defects/${id}`
}

/**
 * @summary Get defect by ID
 */
export const getDefectById = async (id: string, options?: RequestInit): Promise<DefectDTO> => {

  return customFetch<DefectDTO>(getGetDefectByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDefectByIdQueryKey = (id: string,) => {
    return [
    `/api/defects/${id}`
    ] as const;
    }


export const getGetDefectByIdQueryOptions = <TData = Awaited<ReturnType<typeof getDefectById>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefectById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefectByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefectById>>> = ({ signal }) => getDefectById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDefectById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDefectByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDefectById>>>
export type GetDefectByIdQueryError = ErrorResponse


export function useGetDefectById<TData = Awaited<ReturnType<typeof getDefectById>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefectById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefectById>>,
          TError,
          Awaited<ReturnType<typeof getDefectById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefectById<TData = Awaited<ReturnType<typeof getDefectById>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefectById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefectById>>,
          TError,
          Awaited<ReturnType<typeof getDefectById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefectById<TData = Awaited<ReturnType<typeof getDefectById>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefectById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get defect by ID
 */

export function useGetDefectById<TData = Awaited<ReturnType<typeof getDefectById>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefectById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDefectByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDefectUrl = (id: string,) => {




  return `/api/defects/${id}`
}

/**
 * Patches any subset of: description, priority, rectificationDue,
 * comments, equipmentId (re-link within the same site), and
 * clauseReference. Omitted fields are left unchanged.
 *
 * Rectified defects are admin-only — non-admin callers receive
 * `403 DEFECT_LOCKED`.
 * @summary Update mutable defect fields
 */
export const updateDefect = async (id: string,
    updateDefectDTO: UpdateDefectDTO, options?: RequestInit): Promise<DefectDTO> => {

  return customFetch<DefectDTO>(getUpdateDefectUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDefectDTO)
  }
);}





export const getUpdateDefectMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDefect>>, TError,{id: string;data: UpdateDefectDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDefect>>, TError,{id: string;data: UpdateDefectDTO}, TContext> => {

const mutationKey = ['updateDefect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDefect>>, {id: string;data: UpdateDefectDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDefect(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDefectMutationResult = NonNullable<Awaited<ReturnType<typeof updateDefect>>>
    export type UpdateDefectMutationBody = UpdateDefectDTO
    export type UpdateDefectMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Update mutable defect fields
 */
export const useUpdateDefect = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDefect>>, TError,{id: string;data: UpdateDefectDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDefect>>,
        TError,
        {id: string;data: UpdateDefectDTO},
        TContext
      > => {
      return useMutation(getUpdateDefectMutationOptions(options), queryClient);
    }

export const getDeleteDefectUrl = (id: string,) => {




  return `/api/defects/${id}`
}

/**
 * @summary Delete defect by ID
 */
export const deleteDefect = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteDefectUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDefectMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDefect>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDefect>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteDefect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDefect>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDefect(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDefectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDefect>>>

    export type DeleteDefectMutationError = ErrorResponse

    /**
 * @summary Delete defect by ID
 */
export const useDeleteDefect = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDefect>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDefect>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteDefectMutationOptions(options), queryClient);
    }

export const getUpdateDefectStatusUrl = (id: string,) => {




  return `/api/defects/${id}/status`
}

/**
 * @summary Update defect status (rectify, set monitoring)
 */
export const updateDefectStatus = async (id: string,
    updateDefectStatusDTO: UpdateDefectStatusDTO, options?: RequestInit): Promise<DefectDTO> => {

  return customFetch<DefectDTO>(getUpdateDefectStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDefectStatusDTO)
  }
);}





export const getUpdateDefectStatusMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDefectStatus>>, TError,{id: string;data: UpdateDefectStatusDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDefectStatus>>, TError,{id: string;data: UpdateDefectStatusDTO}, TContext> => {

const mutationKey = ['updateDefectStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDefectStatus>>, {id: string;data: UpdateDefectStatusDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDefectStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDefectStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateDefectStatus>>>
    export type UpdateDefectStatusMutationBody = UpdateDefectStatusDTO
    export type UpdateDefectStatusMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Update defect status (rectify, set monitoring)
 */
export const useUpdateDefectStatus = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDefectStatus>>, TError,{id: string;data: UpdateDefectStatusDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDefectStatus>>,
        TError,
        {id: string;data: UpdateDefectStatusDTO},
        TContext
      > => {
      return useMutation(getUpdateDefectStatusMutationOptions(options), queryClient);
    }

export const getCloseOutDefectUrl = (id: string,) => {




  return `/api/defects/${id}/close-out`
}

/**
 * Transitions the defect to `RECTIFIED`, persists `resolutionNotes`, sets
 * `rectifiedAt` to now and `rectifiedBy` to the supplied user (or the
 * authenticated caller's display name if omitted), records the transition on
 * the audit trail, and emits a `DefectStatusUpdated` event.
 *
 * Pre-condition: every corrective action on the defect must already be
 * marked complete (#1318). If any are incomplete the request fails with
 * `409 INCOMPLETE_CORRECTIVE_ACTIONS`.
 * @summary Close out a defect with resolution notes (sets status to RECTIFIED)
 */
export const closeOutDefect = async (id: string,
    closeOutDefectDTO: CloseOutDefectDTO, options?: RequestInit): Promise<DefectDTO> => {

  return customFetch<DefectDTO>(getCloseOutDefectUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(closeOutDefectDTO)
  }
);}





export const getCloseOutDefectMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeOutDefect>>, TError,{id: string;data: CloseOutDefectDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof closeOutDefect>>, TError,{id: string;data: CloseOutDefectDTO}, TContext> => {

const mutationKey = ['closeOutDefect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeOutDefect>>, {id: string;data: CloseOutDefectDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  closeOutDefect(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseOutDefectMutationResult = NonNullable<Awaited<ReturnType<typeof closeOutDefect>>>
    export type CloseOutDefectMutationBody = CloseOutDefectDTO
    export type CloseOutDefectMutationError = ErrorResponse

    /**
 * @summary Close out a defect with resolution notes (sets status to RECTIFIED)
 */
export const useCloseOutDefect = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeOutDefect>>, TError,{id: string;data: CloseOutDefectDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeOutDefect>>,
        TError,
        {id: string;data: CloseOutDefectDTO},
        TContext
      > => {
      return useMutation(getCloseOutDefectMutationOptions(options), queryClient);
    }

export const getSetCorrectiveActionCompletedUrl = (defectId: string,
    id: string,) => {




  return `/api/defects/${defectId}/corrective-actions/${id}/completed`
}

/**
 * Marks the corrective action complete (or incomplete). Used as the
 * gate for defect close-out (#1318).
 * @summary Toggle a corrective action's completed flag
 */
export const setCorrectiveActionCompleted = async (defectId: string,
    id: string,
    setCorrectiveActionCompletedDTO: SetCorrectiveActionCompletedDTO, options?: RequestInit): Promise<CorrectiveActionDTO> => {

  return customFetch<CorrectiveActionDTO>(getSetCorrectiveActionCompletedUrl(defectId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setCorrectiveActionCompletedDTO)
  }
);}





export const getSetCorrectiveActionCompletedMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCorrectiveActionCompleted>>, TError,{defectId: string;id: string;data: SetCorrectiveActionCompletedDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setCorrectiveActionCompleted>>, TError,{defectId: string;id: string;data: SetCorrectiveActionCompletedDTO}, TContext> => {

const mutationKey = ['setCorrectiveActionCompleted'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCorrectiveActionCompleted>>, {defectId: string;id: string;data: SetCorrectiveActionCompletedDTO}> = (props) => {
          const {defectId,id,data} = props ?? {};

          return  setCorrectiveActionCompleted(defectId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetCorrectiveActionCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof setCorrectiveActionCompleted>>>
    export type SetCorrectiveActionCompletedMutationBody = SetCorrectiveActionCompletedDTO
    export type SetCorrectiveActionCompletedMutationError = ErrorResponse

    /**
 * @summary Toggle a corrective action's completed flag
 */
export const useSetCorrectiveActionCompleted = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCorrectiveActionCompleted>>, TError,{defectId: string;id: string;data: SetCorrectiveActionCompletedDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCorrectiveActionCompleted>>,
        TError,
        {defectId: string;id: string;data: SetCorrectiveActionCompletedDTO},
        TContext
      > => {
      return useMutation(getSetCorrectiveActionCompletedMutationOptions(options), queryClient);
    }

export const getListDefectPhotosUrl = (id: string,) => {




  return `/api/defects/${id}/photos`
}

/**
 * Returns the photo gallery for the defect. Photos come from two
 * sources: uploads directly to the defect (`purpose=defect_photo`)
 * and existing inspection photos linked over via document-svc. Each
 * entry includes a presigned download URL and any EXIF / upload
 * metadata captured at upload time.
 * @summary List photos attached to a defect
 */
export const listDefectPhotos = async (id: string, options?: RequestInit): Promise<DefectPhotoResponse[]> => {

  return customFetch<DefectPhotoResponse[]>(getListDefectPhotosUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDefectPhotosQueryKey = (id: string,) => {
    return [
    `/api/defects/${id}/photos`
    ] as const;
    }


export const getListDefectPhotosQueryOptions = <TData = Awaited<ReturnType<typeof listDefectPhotos>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDefectPhotos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDefectPhotosQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDefectPhotos>>> = ({ signal }) => listDefectPhotos(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDefectPhotos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDefectPhotosQueryResult = NonNullable<Awaited<ReturnType<typeof listDefectPhotos>>>
export type ListDefectPhotosQueryError = ErrorResponse


export function useListDefectPhotos<TData = Awaited<ReturnType<typeof listDefectPhotos>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDefectPhotos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDefectPhotos>>,
          TError,
          Awaited<ReturnType<typeof listDefectPhotos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDefectPhotos<TData = Awaited<ReturnType<typeof listDefectPhotos>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDefectPhotos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDefectPhotos>>,
          TError,
          Awaited<ReturnType<typeof listDefectPhotos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDefectPhotos<TData = Awaited<ReturnType<typeof listDefectPhotos>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDefectPhotos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List photos attached to a defect
 */

export function useListDefectPhotos<TData = Awaited<ReturnType<typeof listDefectPhotos>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDefectPhotos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDefectPhotosQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLinkDefectPhotoUrl = (id: string,) => {




  return `/api/defects/${id}/photos/link`
}

/**
 * Materialises a defect_photos row from an existing document
 * (typically an inspection photo from the same inspection that raised
 * the defect). defect-svc fetches the document's metadata from
 * document-svc and inserts the row atomically — no `document.linked`
 * event is published; the link is wholly owned by defect-svc.
 *
 * The document must be on the same site as the defect. Caller must
 * have a site claim on that site and role >= inspector.
 * @summary Attach an existing document to the defect as a photo
 */
export const linkDefectPhoto = async (id: string,
    linkDefectPhotoRequest: LinkDefectPhotoRequest, options?: RequestInit): Promise<DefectPhotoResponse> => {

  return customFetch<DefectPhotoResponse>(getLinkDefectPhotoUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkDefectPhotoRequest)
  }
);}





export const getLinkDefectPhotoMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkDefectPhoto>>, TError,{id: string;data: LinkDefectPhotoRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof linkDefectPhoto>>, TError,{id: string;data: LinkDefectPhotoRequest}, TContext> => {

const mutationKey = ['linkDefectPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkDefectPhoto>>, {id: string;data: LinkDefectPhotoRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  linkDefectPhoto(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkDefectPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof linkDefectPhoto>>>
    export type LinkDefectPhotoMutationBody = LinkDefectPhotoRequest
    export type LinkDefectPhotoMutationError = ErrorResponse

    /**
 * @summary Attach an existing document to the defect as a photo
 */
export const useLinkDefectPhoto = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkDefectPhoto>>, TError,{id: string;data: LinkDefectPhotoRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkDefectPhoto>>,
        TError,
        {id: string;data: LinkDefectPhotoRequest},
        TContext
      > => {
      return useMutation(getLinkDefectPhotoMutationOptions(options), queryClient);
    }

export const getUnlinkDefectPhotoUrl = (defectId: string,
    photoId: string,) => {




  return `/api/defects/${defectId}/photos/${photoId}`
}

/**
 * Deletes the defect_photos row. The underlying document on
 * document-svc is left untouched — other defects or inspections that
 * reference the same document keep their links.
 *
 * Caller must have a site claim on the defect's site and
 * role >= inspector.
 * @summary Remove a photo from a defect
 */
export const unlinkDefectPhoto = async (defectId: string,
    photoId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUnlinkDefectPhotoUrl(defectId,photoId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnlinkDefectPhotoMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkDefectPhoto>>, TError,{defectId: string;photoId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkDefectPhoto>>, TError,{defectId: string;photoId: string}, TContext> => {

const mutationKey = ['unlinkDefectPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkDefectPhoto>>, {defectId: string;photoId: string}> = (props) => {
          const {defectId,photoId} = props ?? {};

          return  unlinkDefectPhoto(defectId,photoId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkDefectPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkDefectPhoto>>>

    export type UnlinkDefectPhotoMutationError = ErrorResponse

    /**
 * @summary Remove a photo from a defect
 */
export const useUnlinkDefectPhoto = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkDefectPhoto>>, TError,{defectId: string;photoId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlinkDefectPhoto>>,
        TError,
        {defectId: string;photoId: string},
        TContext
      > => {
      return useMutation(getUnlinkDefectPhotoMutationOptions(options), queryClient);
    }

export const getAddCorrectiveActionUrl = (id: string,) => {




  return `/api/defects/${id}/corrective-actions`
}

/**
 * @summary Add a corrective action to a defect
 */
export const addCorrectiveAction = async (id: string,
    createCorrectiveActionDTO: CreateCorrectiveActionDTO, options?: RequestInit): Promise<CorrectiveActionDTO> => {

  return customFetch<CorrectiveActionDTO>(getAddCorrectiveActionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCorrectiveActionDTO)
  }
);}





export const getAddCorrectiveActionMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCorrectiveAction>>, TError,{id: string;data: CreateCorrectiveActionDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addCorrectiveAction>>, TError,{id: string;data: CreateCorrectiveActionDTO}, TContext> => {

const mutationKey = ['addCorrectiveAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCorrectiveAction>>, {id: string;data: CreateCorrectiveActionDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  addCorrectiveAction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCorrectiveActionMutationResult = NonNullable<Awaited<ReturnType<typeof addCorrectiveAction>>>
    export type AddCorrectiveActionMutationBody = CreateCorrectiveActionDTO
    export type AddCorrectiveActionMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Add a corrective action to a defect
 */
export const useAddCorrectiveAction = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCorrectiveAction>>, TError,{id: string;data: CreateCorrectiveActionDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCorrectiveAction>>,
        TError,
        {id: string;data: CreateCorrectiveActionDTO},
        TContext
      > => {
      return useMutation(getAddCorrectiveActionMutationOptions(options), queryClient);
    }

